import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const WorkspaceIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue1a0'}</MuiIcon>
    );
}